export const formatNumber = (number: number): string => {
    const numberFormatter = Intl.NumberFormat('no-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    return numberFormatter.format(number)
}
